import React from "react";
import { useSnackBar } from "../../../hooks/useSnackBar";
import "./UserRegistration.css";
import WarehouseList from "./Components/Warehouses/WarehouseList/WarehouseList";
import ShippersList from "./Components/Shippers/ShippersList/ShippersList";
import TruckersList from "./Components/Truckers/TruckersList";
import OneTimeShipperList from "./Components/OneTimeShipper/OneTimeShipperList";
import TabsComponent from "../../../Components/Common/TabsComponent";
import AllUserList from "./Components/AllUserList/AllUserList";
import { useTranslation } from "react-i18next";

const UserRegistration = () => {
  const { t } = useTranslation("admin");
  const [tab, setTab] = React.useState(1);
  const setSnack = useSnackBar();

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div className="dispatcher__screen" style={{ maxWidth: "100%" , padding: "0px 5px"}}>
      <TabsComponent
        items={[
          {
            label: t("users.allUsers"),
            style: { fontWeight: "bold" },
            value: 0,
          },
          {
            label: t("users.shippers"),
            style: { fontWeight: "bold" },
            value: 1,
          },
          { label: t("users.carriers"), style: { fontWeight: "bold" }, value: 2 },
          { label: t("users.threePlTab"), style: { fontWeight: "bold" }, value: 3 },
          {
            label: t("users.oneTimeShippersTab"),
            style: { fontWeight: "bold" },
            value: 4,
          },
        ]}
        tab={tab}
        handleTabChange={handleTabChange}
      />
      {tab === 0 && <AllUserList setSnack={setSnack} />}
      {tab === 1 && <ShippersList setSnack={setSnack} />}
      {tab === 2 && <TruckersList setSnack={setSnack} />}
      {tab === 3 && <WarehouseList setSnack={setSnack} />}
      {tab === 4 && <OneTimeShipperList setSnack={setSnack} />}
    </div>
  );
};

export default UserRegistration;
